var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13C17 13.8284 16.3284 14.5 15.5 14.5C14.6716 14.5 14 13.8284 14 13C14 12.1716 14.6716 11.5 15.5 11.5C16.3284 11.5 17 12.1716 17 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8132 5.72788L15.8132 2.58502C17.4102 2.12872 19 3.32788 19 4.98883V6.00024C20.1046 6.00024 21 6.89567 21 8.00024V18.0002C21 19.1048 20.1046 20.0002 19 20.0002H5C3.89543 20.0002 3 19.1048 3 18.0002V8.00024C3 6.95568 3.83483 6.00741 4.8132 5.72788ZM16.3626 4.50807C16.682 4.41681 17 4.65664 17 4.98883V6.00024H11.1401L16.3626 4.50807ZM5 8.00024H19V18.0002H5C5 15.0153 5 8.00024 5 8.00024Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.81a8f6cb8b252a4dad59ca6cacfc461e.svg";
export { ForwardRef as ReactComponent };